import { Fragment } from 'react';
import { Grid } from '@mui/material';
import { UseFormGetValues } from 'react-hook-form';

import MuiTable from 'components/MuiTable';
import { IPathology } from 'apis/survey/type';
import { formatStringToDate } from 'utils/formatting';

import RowContainer from '../components/RowContainer';
import SectionTitle from '../components/SectionTitle';

interface Props {
  getValues: UseFormGetValues<any>;
}

const Pathologies = ({ getValues }: Props) => {
  const pathologies: IPathology[] = getValues('pathologies');

  const columns = [
    { fieldId: 'pt_pathology_no', label: '序號.' },
    { fieldId: 'pathology_time', label: '時間' },
    { fieldId: 'fee_eng', label: '名稱', width: 300 },
    { fieldId: 'pathology_result', label: '結果', width: 240 },
    { fieldId: 'pathology_range', label: '範圍', width: 240 },
    { fieldId: 'pathology_note', label: '備註', width: 240 },
  ];

  const rows = pathologies?.map(item => ({
    ...item,
    id: item.pt_pathology_no,
    pathology_time: formatStringToDate(item.pathology_time, 'hh:mm a'),
  }));

  return (
    <Fragment>
      <SectionTitle title="臨床病理檢查結果" />
      <RowContainer ratio={12}>
        <Grid item xs={12}>
          <MuiTable columns={columns} rows={rows} />
        </Grid>
      </RowContainer>
    </Fragment>
  );
};

export default Pathologies;
